import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  addUserNotificationAction,
  fetchNotificationsAction,
  updateUserNotificationAction
} from '../../reducers/auth';
import { NOTIFICATION_TYPES } from './constants';
import { updateAnnouncementLocally } from '../../reducers/annoucement';
import { DOCTOR_DEFAULT_PAGE, MANAGEMENT_DEFAULT_PAGE } from '../../constants/default';
import { refreshCase } from '../../reducers/caseFeedback';
import getOrganizationRole from '../../selectors/getOrganizationRole';
import getCurrentOrganization from '../../selectors/getCurrentOrganization';
import { isTechnicianOrAdmin } from '../../helpers';
import { showOnboarding } from '../../reducers/onboardings';
import { EchoContext } from '../EchoProvider';

const WSNotificationHandler = ({ user }) => {
  const dispatch = useDispatch();
  const isManagement = useSelector(state => state.auth.isManagement);
  const organizationRole = useSelector(getOrganizationRole);
  const organization = useSelector(getCurrentOrganization);

  useEffect(() => {
    dispatch(fetchNotificationsAction());
  }, [dispatch]);

  const echo = useContext(EchoContext);

  useEffect(() => {
    if (!echo) {
      return;
    }

    if (isTechnicianOrAdmin(user)) {
      echo.private('internal').listen('.announcement.updated', e => {
        dispatch(updateAnnouncementLocally(e.announcement));
      });
      echo.private('internal').listen('.announcement.updated', e => {
        dispatch(updateAnnouncementLocally(e.announcement));
      });
    }

    echo.private('general').listen('.announcement.updated', e => {
      dispatch(updateAnnouncementLocally(e.announcement));
    });

    echo.private(`App.User.${user.id}`).notification(data => {
      switch (data.type) {
        case NOTIFICATION_TYPES.PATIENT_SETUP_COMPLETED:
          dispatch(
            addUserNotificationAction(
              data,
              isManagement ? MANAGEMENT_DEFAULT_PAGE : DOCTOR_DEFAULT_PAGE
            )
          );
          if (!isManagement) {
            dispatch(refreshCase());
          }

          break;
        case NOTIFICATION_TYPES.NEW_CASE_NOTE:
        case NOTIFICATION_TYPES.NEW_CASE_NOTE_FOR_MANAGEMENT:
        case NOTIFICATION_TYPES.RUSH_CASE:
        case NOTIFICATION_TYPES.TRAY_DESIGN_REQUEST_COMPLETED:
          dispatch(addUserNotificationAction(data, `/patient-details/${data.patient_id}`));
          break;
        case NOTIFICATION_TYPES.UPDATED_NOTIFICATION:
          dispatch(updateUserNotificationAction(data.data, `/patient-details/${data.patient_id}`));
          break;
        case 'refresh-notifications':
          dispatch(fetchNotificationsAction());
          break;
        default:
          break;
      }
    });

    if (organization && !isManagement) {
      echo.private(`organization.${organization.id}`).notification(data => {
        switch (data.type) {
          case 'refresh-notifications':
            dispatch(fetchNotificationsAction());
            break;
          case 'onboarding-changes':
            dispatch(showOnboarding(data.onboarding_id));
            break;
          default:
            break;
        }
      });
    }
  }, [user, user.id, dispatch, isManagement, organization, organizationRole, echo]);

  return null;
};
WSNotificationHandler.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  user: PropTypes.any
};

WSNotificationHandler.defaultProps = {
  user: {}
};

export default WSNotificationHandler;
